var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      class: [
        "hyperlink",
        ..._vm.variantClassList,
        _vm.disabled && "is-disabled"
      ],
      attrs: { href: _vm.href, disabled: _vm.disabled, target: _vm.target },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "span",
        { staticClass: "hyperlink__label" },
        [
          _vm._t("default", function() {
            return [_vm._v(" " + _vm._s(_vm.labelText) + " ")]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }